// extracted by mini-css-extract-plugin
module.exports = {"button":"t1qsJ","buttons":"_2wjkX"};